import { render, staticRenderFns } from "./MStatictisc.vue?vue&type=template&id=14659ce0&scoped=true&"
import script from "./MStatictisc.vue?vue&type=script&lang=js&"
export * from "./MStatictisc.vue?vue&type=script&lang=js&"
import style0 from "./MStatictisc.vue?vue&type=style&index=0&id=14659ce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14659ce0",
  null
  
)

export default component.exports